import React from 'react';
import PropTypes from 'prop-types';

import { Field } from 'react-final-form';

import SearchableDropdownWithCheckboxes from '../../../../SearchableDropdownWithCheckboxes';

import { withTags } from '../../../../../hoc/withTags';
import { withFormUtils } from '../../../../../hoc/withFormUtils';

const propTypes = {
    name: PropTypes.string
};

const TagSelectField = ({ utils, name, tags }) => {
    const handleChange = (id, change, values) => {
        if(!values.includes(id)) {
            return change([...values, id]);
        } else {
            return change(values.filter(val => val !== id));
        }
    };

    const options = tags.map(tag => ({
        id: tag.attributeDictionaryId,
        label: tag.name.find(n => n.iso.toLowerCase() === utils.currentLanguage())?.value,
    }));

    return (
        <Field name={name}>
            {
                props => {
                    const currentSelectionLabel = props.input.value === null || props.input.value === '' || (Array.isArray(props.input.value) && (props.input.value.length === 0))
                        ? 'Wybierz tagi'
                        : (
                            props.input.value.length <= 3
                                ? tags
                                    .filter(tag => props.input.value.includes(tag.attributeDictionaryId))
                                    .map(tag => tag.name.find(n => n.iso.toLowerCase() === utils.currentLanguage())?.value)
                                    .join(', ')
                                : `Wybrano: ${props.input.value.length}`
                        );

                    return (
                        <span className='m-1'>
                            <SearchableDropdownWithCheckboxes
                                name={name}
                                options={options}
                                currentSelectionLabel={currentSelectionLabel}
                                setCheckedIds={(id) => handleChange(id, props.input.onChange, props.input.value)}
                                label='Tagi'
                                checkedIds={props.input.value}
                            />
                        </span>
                    );
                }
            }
        </Field>
    );
};

TagSelectField.propTypes = propTypes;

export default withFormUtils(withTags(TagSelectField));